import styled from 'styled-components';

export const VersionTypeWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding-left: 30px;
  padding-top: 30px;
`;

export const WordWrapper = styled.div`
  display: flex;
  margin: 12px;
`;
